<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VV8k9o/tc-custom/CoverDesign.jpg?1685790639767?1726519294302" alt="This image is the cover for the book Safe and Sound"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Safe and Sound
      </h1>
      <p class="bookDescription body article font2">
        <p>Twenty-one-year-old Mason has to get out of his mother’s house, where her boyfriend subjects him to unwanted advances—and won’t take no for an answer. Since she didn’t believe Mason when he told her about his uncle’s sexual abuse, Mason knows he’s on his own, and it’s up to him to raise the money he needs. He thinks he’s in luck when he takes a modeling job. </p><p>Oliver is a photographer, and getting guys and sex has always been easy for him. His current open relationship is no exception: more friendship and fun than anything. But when Oliver meets Mason, he can see the younger man is fragile and desperately in need of help. Before anything can develop between them, Mason needs to free himself of his terrible living situation and start on the road to healing. Oliver wants to stand beside him as he does. What surprises him is the discovery that he might need Mason as much as Mason needs him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caitlin Ricci
      </h2>
      
      <p class="authorDescription body article"><P>Caitlin is the author of over 150 queer romance books including some Rainbow Award winners. When she&rsquo;s not writing, she enjoys gardening, hanging out with her dogs, and watching movies with her husband. She is a panromantic asexual and she lives on a small farm in Missouri where she enjoys the quiet life of a good cup of tea and her dogs asleep on the deck.</P><P>Website: www.CaitlinRicci.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b8537ea